const $ = require('../../node_modules/jquery/dist/jquery.min')

module.exports = {
  init: () => {
    const closeButton = $('.notice-close')
    const notice = $('.notice')
    closeButton.on('click', function (e) {
      $(this)
        .closest(notice)
        .addClass('notice--dismissed')
      return false
    })
  }
}
